import { Badge, Box, List, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { SIDEBAR } from '../theme';
import { NAV_GROUPS } from './nav';

/** The dark blue menu on the left (a slide-out drawer on a phone) */
export function SideMenu({ approvals, onPick }: { approvals: number; onPick?: () => void }) {
  return (
    <Box
      component="nav"
      sx={{
        bgcolor: SIDEBAR.bg,
        color: SIDEBAR.text,
        height: '100%',
        overflowY: 'auto',
        pt: 'env(safe-area-inset-top)',
      }}
    >
      <Stack direction="row" spacing={1.25} sx={{ alignItems: 'center', px: 2.5, py: 2.25 }}>
        <Box component="img" src="/icons/icon-192.png" alt="" sx={{ width: 34, height: 34, borderRadius: 1.5 }} />
        <Box>
          <Typography sx={{ color: '#fff', fontWeight: 800, letterSpacing: '.06em', lineHeight: 1.1 }}>SERB</Typography>
          <Typography sx={{ color: '#5b9cf5', fontSize: 10, fontWeight: 700, letterSpacing: '.18em' }}>
            EXPRESS
          </Typography>
        </Box>
      </Stack>
      {NAV_GROUPS.map((group) => (
        <List key={group.title ?? 'top'} dense sx={{ px: 1.25, py: 0.5 }}>
          {group.title && (
            <Typography
              sx={{ px: 1.5, py: 1, fontSize: 11, fontWeight: 700, letterSpacing: '.08em', color: '#7f93bd' }}
            >
              {group.title.toUpperCase()}
            </Typography>
          )}
          {group.items.map((item) => (
            <ListItemButton
              key={item.to}
              component={NavLink}
              to={item.to}
              end={item.to === '/'}
              onClick={onPick}
              sx={{
                borderRadius: 2,
                mb: 0.25,
                minHeight: 44,
                color: 'inherit',
                '&.active': { bgcolor: SIDEBAR.active, color: '#fff' },
                '&:hover': { bgcolor: 'rgba(255,255,255,.08)' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 38, color: 'inherit' }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} slotProps={{ primary: { sx: { fontSize: 14.5, fontWeight: 500 } } }} />
              {item.badge === 'approvals' && approvals > 0 && (
                <Badge badgeContent={approvals} color="error" sx={{ mr: 1 }} />
              )}
            </ListItemButton>
          ))}
        </List>
      ))}
    </Box>
  );
}
